import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { UPDATE_FIELD_REGISTRY, UPDATE_FIELD_REGISTRY_SUCCESS, UPDATE_FIELD_REGISTRY_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateFieldRegistry({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/field-registry/${payload?.fieldId}`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(response?.data?.message || 'Field updated successfully.');
      yield put({
        type: UPDATE_FIELD_REGISTRY_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || 'Failed to update field.';
      cogoToast.error(message);
      yield put({
        type: UPDATE_FIELD_REGISTRY_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error('Failed to update field.');
    yield put({ type: UPDATE_FIELD_REGISTRY_ERROR, payload: error });
  }
}

export function* watchupdateFieldRegistry() {
  yield takeEvery(UPDATE_FIELD_REGISTRY, updateFieldRegistry);
}

function* updateFieldRegistrySaga() {
  yield all([fork(watchupdateFieldRegistry)]);
}

export default updateFieldRegistrySaga;
